<div class="app-content-container">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- Logo Box -->
    <header class="login-header w-4/5 place-content-center">
      <a class="company-logo-container" target="_blank" href="https://www.lufthansagroup.com/de/home.html" rel="noopener">
        <img class="h-[2rem]" [src]="logoUrl" alt="LOGO" />
      </a>

      <sp-mobile-navigation class="toggle-button-top-right">
        <sp-footer></sp-footer>
      </sp-mobile-navigation>
    </header>

    <div class="login-main max-w-screen-sm place-content-center">
      <div class="flex flex-col justify-center h-full mb-2">
        <!-- Loader -->
        <sp-loading-inprogress *ngIf="loading; else content" [showSpinner]="true"></sp-loading-inprogress>
        <!-- !END Loader -->

        <!-- Content -->
        <ng-template #content>
          <div class="flex flex-col justify-center h-full mb-2 confirm-email">
            <ng-container *ngIf="errorMessage.length; else success">
              <h2 class="text-center text-xl font-bold text-red-600" i18n>There was an error confirming your e-mail address!</h2>
            </ng-container>
            <ng-template #success>
              <h2 class="text-center text-lg mt-8 font-bold" i18n>Your e-mail address is confirmed!</h2>
              <p class="text-center text-sm my-6 mx-8" i18n>As soon as your account is approved and configured, we will notify you.</p>
            </ng-template>

            <!-- Back to login page -->
            <div class="flex flex-col justify-center mt-8">
              <a class="text-center font-bold underline text-sm link-color" [routerLink]="['/login']" i18n>Back to login</a>
            </div>
          </div>
        </ng-template>
        <!-- !END Content -->
      </div>
    </div>
  </div>
</div>
<div class="app-footer-container">
  <div class="flex flex-col justify-end h-full mb-2">
    <lh-footer></lh-footer>
    <!-- /Footer -->
    <sp-footer></sp-footer>
  </div>
</div>
